import { styled } from 'src/stitches'

export const Root = styled('div', {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '$gray4',
})
